export function transformAriaKebabCase(
  props: Record<string, unknown>,
): Record<string, unknown> {
  const ariaAttributes: Record<string, unknown> = {};

  Object.entries(props).forEach(([key, value]) => {
    if (typeof key === 'string' && key.startsWith('aria')) {
      const transformedKey = `aria-${key.slice(4).toLowerCase()}`;
      ariaAttributes[transformedKey] = value;
    }
  });

  return ariaAttributes;
}
